import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

const SubscriptionHistoryList = () => {

  const navigate = useNavigate();

  const rows = [
    {
      id: 1,
      userName: "Madelyn Dias",
      userEmail: "madelyndias@gmail.com",
      plan: "Basic Plan",
      date: "24 Jul 2025",
      paymentMethod: "Stripe",
      status: "Active",
      statusClass: "c_success"
    },
    {
      id: 3,
      userName: "Madelyn Dias",
      userEmail: "madelyndias@gmail.com",
      plan: "Basic Plan",
      date: "--",
      paymentMethod: "--",
      status: "Expired",
      statusClass: "c_danger"
    },
    {
      id: 4,
      userName: "Madelyn Dias",
      userEmail: "madelyndias@gmail.com",
      plan: "Basic Plan",
      date: "--",
      paymentMethod: "--",
      status: "Canceled",
      statusClass: "c_dark"
    },
  ];

  return (
    <>
      <TableContainer className="table_container">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Service Providers</TableCell>
              <TableCell>Plan</TableCell>
              <TableCell>Renewal Date</TableCell>
              <TableCell>Payment Method</TableCell>
              <TableCell>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow hover key={row.id}>
                <TableCell>
                  <a
                    href="/manage-users/detail"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/manage-users/detail");
                    }}
                    className="user_block click_action"
                  >
                    <figure>
                      <img src="/static/images/user_placeholder.png" alt="User avatar" />
                    </figure>
                    <p>
                      <b>{row.userName}</b>
                      <span>{row.userEmail}</span>
                    </p>
                  </a>

                </TableCell>
                <TableCell>{row.plan}</TableCell>
                <TableCell>{row.date}</TableCell>
                <TableCell>{row.paymentMethod}</TableCell>
                <TableCell><span className={`status_btn ${row.statusClass}`}>{row.status}</span></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default SubscriptionHistoryList;
